/**
 * context/AuthContext.jsx — Updated with is_readonly and allowed_client_ids
 */
import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { auth, token } from "../api/client";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token.get()) {
      auth.me()
        .then(setUser)
        .catch(() => { token.clear(); setUser(null); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const handle = () => setUser(null);
    window.addEventListener("auth:logout", handle);
    return () => window.removeEventListener("auth:logout", handle);
  }, []);

  const login = useCallback(async (email, password) => {
    await auth.login(email, password);
    const me = await auth.me();
    setUser(me);
    return me;
  }, []);

  const logout = useCallback(() => {
    auth.logout();
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      login,
      logout,
      isAdmin:    user?.is_admin    || false,
      isReadonly: user?.is_readonly || false,
      isLimited:  user?.is_limited  || false,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
};
